import { UUID_REGEX } from '@/constants';
import { stripStreamingCursor } from '@/utils/streamingCursor';

export const cleanChatMessageForCopy = (content: string): string => {
  // Intentionally minimal: only remove citation markers and the spacing artifacts they leave.
  return (
    stripStreamingCursor(content)
      .replace(UUID_REGEX, '')
      // Collapse multiple spaces left behind after marker removal.
      .replace(/ {2,}/g, ' ')
      // When a citation marker is between a word and punctuation, removing it can leave "word ."
      .replace(/(\S)\s+([.,;:!?])/g, '$1$2')
      // Also trim trailing whitespace per line (common after marker removal at EOL).
      .replace(/[ \t]+$/gm, '')
      .trim()
  );
};
